const hasActiveBlogAuthorAccess = (access = null) => {
  if (!access) {
    return false;
  }

  if (Array.isArray(access)) {
    return access.some(hasActiveBlogAuthorAccess);
  }

  if (typeof access !== 'object') {
    return Boolean(access);
  }

  if (Array.isArray(access.items)) {
    return access.items.some(hasActiveBlogAuthorAccess);
  }

  if (Array.isArray(access.results)) {
    return access.results.some(hasActiveBlogAuthorAccess);
  }

  if (access.isActive === false || access.is_active === false) {
    return false;
  }

  return Boolean(
    access.isActive === true ||
      access.is_active === true ||
      access.id ||
      access.authSubjectId ||
      access.auth_subject_id ||
      access.loginEmail ||
      access.login_email ||
      access.email ||
      access.author
  );
};

export const buildYowanCurrentUser = ({
  isAuthenticated = false,
  canAccessAdmin = false,
  canAccessStakeholder = false,
  canAccessRelatedSeminars = false,
  canAccessRelatedClasses = false,
  isInstructor = false,
  isOrganizer = false,
  instructorAccess = null,
  organizerAccess = null,
  contentPermissions = {},
  blogContentPermissions = {},
  blogAuthorAccess = null,
  canAccessBlogAuthor = false,
  canViewMyPage = false,
  permissions = [],
  accessToken = null,
  refreshToken = null,
  authSummary = null,
  user = null,
} = {}) => {
  const hasStakeholderAccess = Boolean(
    canAccessStakeholder ||
    canAccessRelatedSeminars ||
    canAccessRelatedClasses ||
    isInstructor ||
    isOrganizer ||
    instructorAccess ||
    organizerAccess
  );
  const hasBlogAuthorAccess = Boolean(
    canAccessBlogAuthor ||
    hasActiveBlogAuthorAccess(blogAuthorAccess)
  );
  const role = !isAuthenticated
    ? 'anonymous'
    : canAccessAdmin
      ? 'admin-ready'
      : hasStakeholderAccess
        ? 'stakeholder-ready'
        : hasBlogAuthorAccess
          ? 'blog-author-ready'
          : 'authenticated';

  return {
    role,
    isAnonymous: role === 'anonymous',
    isAuthenticated,
    canAccessAdmin,
    canAccessStakeholder: hasStakeholderAccess,
    canAccessRelatedSeminars,
    canAccessRelatedClasses,
    isInstructor,
    isOrganizer,
    instructorAccess,
    organizerAccess,
    contentPermissions,
    blogContentPermissions,
    blogAuthorAccess,
    canAccessBlogAuthor: hasBlogAuthorAccess,
    canViewMyPage: Boolean(canViewMyPage || isAuthenticated),
    canCreateBlogPost: Boolean(blogContentPermissions?.canCreate),
    canEditOwnBlogPosts: Boolean(blogContentPermissions?.canEditOwn),
    canPublishOwnBlogPosts: Boolean(blogContentPermissions?.canPublishOwn),
    canManageAllBlogPosts: Boolean(blogContentPermissions?.canManageAll),
    permissions,
    email: user?.email ?? null,
    hasAccessToken: Boolean(accessToken),
    hasRefreshToken: Boolean(refreshToken),
    authSummaryVersion: authSummary?.auth_summary_version || authSummary?.authSummaryVersion || null,
  };
};
